import { BREAKPOINT } from './vars';

export const IPAD_MEDIA = `@media (max-width: ${BREAKPOINT.IPAD}px)`;
export const PHONE_MEDIA = `@media (max-width: ${BREAKPOINT.PHONE}px)`;
export const TABLET_MEDIA = `@media (min-width: ${BREAKPOINT.PHONE + 1}px) and (max-width: ${BREAKPOINT.IPAD}px)`;
